<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="6">
        <v-card class="shadowCard">

          <v-card-title>
            <v-spacer></v-spacer>
            <v-img src="@/assets/logo.png"></v-img>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>

            <label>Selecciona una opción</label>

            <v-row>
              <v-col cols="12">
                <v-radio-group
                  v-model="opCompra"
                  row
                >
                  <v-radio
                    label="Prospecto"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Mercancía"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Contrato"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            

            <v-divider class="my-6"></v-divider>

            <label class="text-h5" v-if="opCompra != 2 && opCompra">Datos del cliente</label>

            <v-row v-if="opCompra != 2 && opCompra">
              <v-col cols="12" lg="8">
                <v-text-field
                  v-model="cliente"
                  label="Nombre Completo"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" lg="4">
                <v-text-field
                  v-model="telefono"
                  label="Teléfono"
                  filled
                  dense
                  type="number"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            

            <v-row v-if="opCompra == 1">
              <v-col cols="6">
                <v-text-field
                  v-model="email"
                  label="email"
                  filled
                  dense
                  type="mail"
                  hide-details
                ></v-text-field>
                
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="direccion"
                  label="Colonia"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- MERCANCIA -->
            <v-row v-if="opCompra == 2">
              <v-col cols="12">
                <label class="text-h5">Selecciona los extras</label>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="mercancia"
                  :items="extras"
                  label="Buscar un extra"
                  item-text="extra"
                  item-value="idextras"
                  hide-details
                  return-object
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="cantidad"
                  label="Cantidad"
                  filled
                  dense
                  type="number"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-btn
                  @click="addMercancia( )"
                  color="primary"
                  dark
                  v-if="mercancia"
                > 
                  <v-icon>mdi-plus</v-icon>                         
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headersMercancia"
                  :items="mercancias"
                  class="elevation-0"
                  hide-default-footer
                  :items-per-page="mercancias.length"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="deleteMercancia(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-col cols="12" v-if="detalleMeet && detalleMeet.detalles" class="pl-4 black--text">
                Detalles del evento<br/>
                - 2 a 3 horas de evento<br/>
                - Puedes grabar tiktoks, pedir saludos, tomarte fotos<br/>
                - Hay snack<br/>
                - Hay aguas frescas<br/>
                - Hay juegos y dinámicas<br/>
                - Sesión de preguntas<br/>
                - Premios<br/>
              </v-col>

              <v-col cols="12" md="8" lg="6">
                <span class="text-h5 black--text">Total a pagar: ${{  totalMercancia }}</span>
                <v-text-field
                  v-model="montoIngresado"
                  label="Pagó"
                  filled
                  dense
                  type="number"
                  hide-details
                ></v-text-field>
                <span class="text-h5 black--text">Cambio: {{ cambio }}</span>
              </v-col>


              <v-col cols="12">
                <label class="text-h5"><b>Selecciona el tipo de pago</b></label>

                <v-radio-group
                  v-model="tipo_pago"
                  row
                >
                  <v-radio
                    label="Efectivo"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Tarjeta"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </v-col>

            </v-row>
            <!-- MERCANCIA -->

            <!-- CONTRATO -->
            <v-row v-if="opCompra == 3">
              <v-col cols="12">
                <label>Datos del contrato</label>
              </v-col>

              <v-col cols="12">
                <span class="text-h5" v-if="!sucursal"><b>Selecciona una sucursal: </b></span>
                <span class="text-h5" v-if="sucursal"><b>Seleccionaste la sucursal de: {{ sucursales.find( el => el.idsucursales == sucursal ) ?sucursales.find( el => el.idsucursales == sucursal ).sucursal : ''  }}</b></span>
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="sucursal"
                  :items="sucursales"
                  label="Selecciona un sucursal"
                  item-text="sucursal"
                  item-value="idsucursales"
                  hide-details
                >
                </v-autocomplete>

              </v-col>

              <v-col cols="12">
                <span class="text-h5"><b>Seleccionaste el día de: {{ textoFecha }}</b></span>
                <v-text-field
                  v-model="dia"
                  label="Día"
                  filled
                  dense
                  type="date"
                  hide-details
                ></v-text-field>

              </v-col>

              <v-col cols="12">
                <label class="text-h5" v-if="!idturnos"><b>Horario de la fiesta</b></label>
                <label class="text-h5" v-if="idturnos"><b>Seleccionaste el horario: {{ turnos.find( el => el.idturnos == idturnos ) ? turnos.find( el => el.idturnos == idturnos ).turno : ''  }}</b></label>
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="idturnos"
                  :items="turnos"
                  label="Selecciona un horario"
                  item-text="turno"
                  item-value="idturnos"
                  hide-details
                >
                </v-autocomplete>

              </v-col>

              <v-col cols="12">
                <label class="text-h5" v-if="!horario"><b>Tipo de fiesta</b></label>
                <label class="text-h5" v-if="horario"><b>Seleccionaste: {{ filterHorarios.find( el => el.idhorarios == horario ) ? filterHorarios.find( el => el.idhorarios == horario ).horario : ''  }}</b></label>
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="horario"
                  :items="filterHorarios"
                  label="Selecciona un tipo de fiesta"
                  item-text="horario"
                  item-value="idhorarios"
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" @click="bloquearFecha( )" v-if="!fechaValida">Valida Disponibilidad</v-btn>
                <v-btn color="primary" @click="desbloquearFecha( )" v-else>Cambiar fecha</v-btn>
              </v-col>
            </v-row>

            <v-row v-if="fechaValida && opCompra == 3">

              <!-- AGREGAR UN PLATILLO -->
              <v-col cols="12">
                <label class="text-h5"><b>Selecciona la comida y número de personas</b></label>
              </v-col>
              <v-col cols="12" md="10">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="platillo"
                  :items="filterPlatillos"
                  label="Buscar un platillo"
                  item-text="platillo_completo"
                  item-value="idplatillos"
                  hide-details
                  return-object
                  :readonly="platillosSeleccionados.length > 0 ? true : false "
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="2">
                <v-btn
                  @click="platillosSeleccionados.push( platillo ), platillo = null"
                  color="primary"
                  v-if="platillo"
                  dark
                > 
                  <v-icon>mdi-plus</v-icon>                         
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headersPlatillos"
                  :items="platillosSeleccionados"
                  hide-default-footer
                  :items-per-page="platillosSeleccionados.length"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="deletePlatillos(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-divider class="my-4"></v-divider>

              <!-- AGREGAR UN PLATILLO -->
              <v-col cols="12">
                <label class="text-h5"><b>Selecciona los adicionales</b></label>
              </v-col>
              <v-col cols="12" md="10">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="articulo"
                  :items="articulos"
                  label="Buscar un articulo"
                  item-text="articulo_completo"
                  item-value="idarticulos"
                  hide-details
                  return-object
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="2">
                <v-btn
                  @click="articulosSeleccionados.push( articulo ), articulo = null"
                  color="primary"
                  v-if="articulo"
                  dark
                > 
                  <v-icon>mdi-plus</v-icon>                         
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headersArticulos"
                  :items="articulosSeleccionados"
                  hide-default-footer
                  :items-per-page="articulosSeleccionados.length"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="deletArticulos(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-divider class="my-4"></v-divider>

              <v-col cols="12">
                <label class="text-h5"><b>Selecciona los extras</b></label>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="mercancia"
                  :items="extras"
                  label="Buscar un extra"
                  item-text="extra"
                  item-value="idextras"
                  hide-details
                  return-object
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="cantidad"
                  label="Cantidad"
                  filled
                  dense
                  type="number"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-btn
                  @click="addMercancia( )"
                  v-if="mercancia"
                  color="primary"
                  dark
                > 
                  <v-icon>mdi-plus</v-icon>                         
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headersMercancia"
                  :items="mercancias"
                  class="elevation-0"
                  hide-default-footer
                  :items-per-page="mercancias.length"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="deleteMercancia(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-col cols="12" v-if="detalleMeet && detalleMeet.detalles" class="pl-4 black--text">
                Detalles del evento<br/>
                - 2 a 3 horas de evento<br/>
                - Puedes grabar tiktoks, pedir saludos, tomarte fotos<br/>
                - Hay snack<br/>
                - Hay aguas frescas<br/>
                - Hay juegos y dinámicas<br/>
                - Sesión de preguntas<br/>
                - Premios<br/>
              </v-col>

              <v-divider class="my-4"></v-divider>

              <v-col cols="12">
                <span class="text-h5 black--text">Total a pagar de la fiesta: ${{  total_pago_fiesta }}</span>
                <br/>
                <span class="text-h5 black--text">Total a pagar de la mercancia: ${{  total_mercancia }}</span>
                <br/>
                <br/>
                <span class="text-h5 black--text">Total a pagar (Fiesta + Mercancía): ${{  total_pago_fiesta + total_mercancia }}</span>
                <br/>
                <v-text-field
                  v-model="anticipo"
                  label="Monto de anticipo + mercancía"
                  hide-details
                  filled
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="faltante"
                  label="Faltante"
                  hide-details
                  filled
                  type="number"
                  readonly
                >
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <label class="text-h5"><b>Selecciona el tipo de pago</b></label>

                <v-radio-group
                  v-model="tipo_pago"
                  row
                >
                  <v-radio
                    label="Efectivo"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Tarjeta"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12">
                <v-alert
                  dense
                  outlined
                  type="error"
                  class="text-h5"
                >
                  Recuerda que la mercancía se debe pagar al momento, así que, el pago debe ser el monto del anticipo + el monto de la mercancía
                </v-alert>
              </v-col>

            </v-row>
            <!-- CONTRATO -->


          </v-card-text>

          <v-card-actions>
            <v-spacer v-if="opCompra == 1"></v-spacer>
            <v-btn
              color="primary"
              @click="saveCliente( )"
              v-if="opCompra == 1"
            >
              Guardar
            </v-btn>

            <!-- SECCION BONOTES PAGO 2 -->
            <v-btn
              color="red"
              dark
              @click="mercancias = [], cliente = null, email = null, telefono = null, pago = null, opCompra = null"
              v-if="opCompra == 2"
              class="mr-2"
            >
              Cancelar compra
            </v-btn>

            <v-spacer v-if="opCompra == 2"></v-spacer>

            <v-btn
              color="primary"
              @click="dialogConfirmarCompra = true"
              v-if="opCompra == 2 && totalMercancia == pago && tipo_pago"
            >
              Confirmar
            </v-btn>

            <v-btn
              color="primary"
              v-if="opCompra == 2 && ( !totalMercancia ||  !pago || !tipo_pago )"
            >
              Llena los datos
            </v-btn>


            <!-- SECCION BONOTES PAGO 3 -->
            <v-spacer v-if="opCompra == 3"></v-spacer>

            <v-btn
              color="primary"
              @click="dialogConfirmarContrato = true"
              v-if="opCompra == 3 & ( anticipo > ( total_mercancia + 499 ) ) "
            >
              Confirmar
            </v-btn>

          </v-card-actions>
        </v-card>
        
      </v-col>
    </v-row>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el proveedor?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogConfirmarCompra" max-width="500px">
      <v-card>
        <v-card-title>
          ¿Estás seguro de confirmar está compra?
        </v-card-title>
        <v-card-text>

          <v-row>
            <v-col cols="12" v-if="recogerSucursal">
              <v-text-field
                v-model="email"
                label="email"
                filled
                dense
                type="mail"
                hide-details
              ></v-text-field>
              
            </v-col>

            <!-- <v-col cols="6">
              <v-text-field
                v-model="direccion"
                label="Colonia"
                filled
                dense
                hide-details
              ></v-text-field> -->
            </v-col>

            <v-col cols="6" v-if="tipo_pago == 2">
              <v-text-field
                v-model="folio_pago"
                label="Folio de ticket"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            @click="dialogConfirmarCompra = false"
          >Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            @click="saveCompra( )"
            v-if="recogerSucursal && email || ( !recogerSucursal && !email)"
          >Sí, confirmo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogConfirmarContrato" max-width="800px">
      <v-card>
        <v-card-title>
          ¿Estás seguro de confirmar este contrato?
        </v-card-title>
        <v-card-text>

          <v-row>
            <v-col cols="12" class="black--text">
              <b>Nombre</b> : {{ cliente }}<br/>
              <b>Fecha</b>  : {{ textoFecha }}<br/>
              <b>Sucursal</b>: {{ sucursales.find( el => el.idsucursales == sucursal ) ?sucursales.find( el => el.idsucursales == sucursal ).sucursal : ''  }}<br/>
              <b>Horario</b>: {{ turnos.find( el => el.idturnos == idturnos ) ? turnos.find( el => el.idturnos == idturnos ).turno : ''  }}<br/>
              <b>Costo</b>: {{ total_pago }}<br/>
              <b>Anticipo</b>: {{ anticipo }}<br/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <label class="black--text text-h6">Platillos seleccionados</label>
              <v-data-table
                :headers="headersPlatillos"
                :items="platillosSeleccionados"
                hide-default-footer
                :items-per-page="platillosSeleccionados.length"
              >
              </v-data-table>
            </v-col>

            <v-col cols="12">
              <label class="black--text text-h6">Adicionales seleccionados</label>
              <v-data-table
                :headers="headersArticulos"
                :items="articulosSeleccionados"
                hide-default-footer
                :items-per-page="articulosSeleccionados.length"
              >
              </v-data-table>
            </v-col>

            <v-col cols="12">
              <label class="black--text text-h6">Mercancía seleccionada</label>
              <v-data-table
                :headers="headersMercancia"
                :items="mercancias"
                class="elevation-0"
                hide-default-footer
                :items-per-page="mercancias.length"
              >
              </v-data-table>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="festejado"
                label="Festejad"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field
                v-model="email"
                label="email"
                filled
                dense
                type="mail"
                hide-details
              ></v-text-field>
              
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="direccion"
                label="Colonia"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="segundo_contacto"
                label="WhatsApp Secundario"
                filled
                dense
                type="number"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="6" v-if="tipo_pago == 2">
              <v-text-field
                v-model="folio_pago"
                label="Folio de ticket"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>

          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            @click="dialogConfirmarContrato = false"
          >Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            @click="addContrato( )"
          >Sí, confirmo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,

      montoIngresado: 0,
      
      editedIndex: -1,

      editedItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        fecha_creacion:null,
        deleted:null,
      },

      defaultItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        personas:0,
        precio:0,
        fecha_creacion:null,
        deleted:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      contratos: [],

      idturnos:null,

      headers: [
        { text: 'ID'            , value: 'idcontratos'    },
        { text: 'Cliente'       , value: 'cliente'        },
        { text: 'Sucursal'      , value: 'sucursal'       },
        { text: 'Fecha'         , value: 'dia'            },
        { text: 'Horario'       , value: 'horario'        },
        { text: 'Anticipo'      , value: 'anticipo'       },
        { text: 'Faltante'      , value: 'faltante'       },
        { text: 'Estatus'       , value: 'estatus'        },
        { text: 'Alta'          , value: 'fecha_creacion' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],

      proveedores: [],
      horarios:[],
      clientes:[],
      extras:[],
      articulos:[],
      articulo: null,
      platillos:[],
      e1: 1,
      clienteManual: false,
      cliente: null,
      email: null,
      telefono: null,
      direccion: null,
      festejado:'',
      dia: null,
      hora:null,
      tematica:null,
      porcumplir:null,

      sucursales:[],

      sucursal: null,

      searchArticulos:'',
      headersArticulos: [
        { text: 'Adicional'     , value: 'adicional'      },
        { text: 'Proveedor'     , value: 'proveedor'      },
        { text: 'Artículo'      , value: 'articulo'       },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Actions'       , value: 'actions'        }
      ],
      articulosSeleccionados: [],

      searchPlatillos:'',
      headersPlatillos: [
        { text: 'Platillo'      , value: 'platillo'       },
        { text: 'Horarios'      , value: 'horario'        },
        { text: 'Personas'      , value: 'personas'       },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Actions'       , value: 'actions'        }
      ],
      platillosSeleccionados: [],

      searchExtras:'',
      headersExtras: [
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Actions'       , value: 'actions'        }
      ],
      extrasSeleccionados: [],

      anticipo:null,
      tipo_pago:null,

      horario: null,
      opCompra:null,

      mercancia:null,
      platillo:null,

      headersMercancia: [
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Cantidad'      , value: 'cantidad'       },
        { text: 'Total'         , value: 'total'          },
        { text: 'Actions'       , value: 'actions'        }
      ],

      cantidad: 1,
      mercancias:[],
      dialogConfirmarCompra: false,
      pago: null,
      fechaValida: false,
      dialogConfirmarContrato: false,
      turnos: [{idturnos: 1, turno: 'Matutino'},{idturnos: 2, turno: 'Vespertino'},{idturnos: 3, turno: 'Nocturno'}],

      textoFecha: '',
      segundo_contacto:null,
      folio_pago: null,
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar proveedor' : 'Editar el proveedor'
      },

      total_pago_fiesta( ){

        let pagoAdicionales = this.articulosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
        let pagoPlatillos   = this.platillosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);

        let sumaTotal = pagoAdicionales + pagoPlatillos 

        return ( sumaTotal )

      },

      total_mercancia( ){

        let pagoExtras      = this.mercancias.reduce((acc, producto) => acc + parseFloat( producto.total ), 0);

        return ( pagoExtras )

      },

      total_pago( ){

        return ( this.total_pago_fiesta + this.total_mercancia )
      },

      totalMercancia( ){

        return this.mercancias.reduce((acc, producto) => acc + parseFloat( producto.precio * producto.cantidad ), 0);

      },


      faltante( ){

        return this.total_pago - this.anticipo

      },

      filterHorarios( ){

        return this.horarios.filter( el => el.idsucursales == this.sucursal )
      },

      filterPlatillos( ){

        return this.platillos.filter( el => el.idsucursales == this.sucursal && el.idhorarios == this.horario )

      },


      cambio( ){

        return this.montoIngresado >= this.totalMercancia ? this.montoIngresado - this.totalMercancia : 0

      },

      recogerSucursal( ){
        return this.mercancias.find( el => el.extra.match('Sucursal') || el.idextras == 11 )
      },

      detalleMeet( ){

        return this.mercancias.find( el => el.idextras == 11 )
        // return this.mercancias.find( el => el.extra.match('Meet') )

      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      sucursal( ){
        this.fechaValida = false
      },

      dia( ){
        this.fechaValida = false

        this.textoFecha = this.dia ? this.formattedDate( ) : ''
      },

      horario( ){
        this.fechaValida = false
      },

      montoIngresado( value ){


        if( value ){

          this.pago = this.totalMercancia

        }
      },


    },

    async created () {
      await this.initialize()
      await this.getProveedores( )
      await this.getClientes( )
      await this.getSucursales( )
      await this.getExtras( )
      await this.getArticulos( )
      await this.getPlatillos( )
      await this.getHorarios( )
    },

    methods: {
      initialize () {
        this.cargar = true
        this.contratos = []
        return this.$http.get('contratos.list').then(response=>{
          this.contratos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getProveedores () {
        this.cargar = true
        this.proveedores = []
        return this.$http.get('proveedores.list').then(response=>{
          this.proveedores = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      formattedDate() {
        const fecha = new Date(this.dia+'T00:00:00-06:00'); // Obtiene la fecha y hora actual

        // Ajusta la fecha a la zona horaria de Monterrey, México
        const opciones = { timeZone: 'America/Mexico_City' };
        const fechaLocal = new Date(fecha.toLocaleString('en-US', opciones));

        // Nombres de los días y meses en español
        const diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
        const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        // Extrae las partes de la fecha
        const diaSemana = diasSemana[fechaLocal.getDay()];
        const dia = fechaLocal.getDate();
        const mes = meses[fechaLocal.getMonth()];
        const año = fechaLocal.getFullYear();

        // Formatea la fecha
        const fechaFormateada = `${diaSemana} ${dia} de ${mes} del ${año}`;

        return fechaFormateada


      },

      deleteMercancia( objeto ){
        // Buscar la posición del objeto
        const indice = this.mercancias.findIndex((item) => item.idextras == objeto.idextras);

        // Si el objeto existe, eliminarlo
        if (indice !== -1) {
          this.mercancias.splice(indice, 1); // Elimina 1 elemento en la posición `indice`
        }
      },

      deletePlatillos( objeto ){
        // Buscar la posición del objeto
        const indice = this.platillosSeleccionados.findIndex((item) => item.idplatillos == objeto.idplatillos);

        // Si el objeto existe, eliminarlo
        if (indice !== -1) {
          this.platillosSeleccionados.splice(indice, 1); // Elimina 1 elemento en la posición `indice`
        }
      },

      deletArticulos( objeto ){
        // Buscar la posición del objeto
        const indice = this.articulosSeleccionados.findIndex((item) => item.idarticulos == objeto.idarticulos);

        // Si el objeto existe, eliminarlo
        if (indice !== -1) {
          this.articulosSeleccionados.splice(indice, 1); // Elimina 1 elemento en la posición `indice`
        }
      },

      getClientes () {
        this.cargar = true
        this.clientes = []
        return this.$http.get('clientes.list').then(response=>{
          this.clientes = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getSucursales () {
        this.cargar = true
        this.sucursales = []
        return this.$http.get('sucursales.list').then(response=>{
          this.sucursales = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getExtras () {
        this.cargar = true
        this.extras = []
        return this.$http.get('extras.list').then(response=>{
          this.extras = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getArticulos () {
        this.cargar = true
        this.articulos = []
        return this.$http.get('articulos.list').then(response=>{
          this.articulos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getPlatillos () {
        this.cargar = true
        this.platillos = []
        return this.$http.get('platillos.list').then(response=>{
          this.platillos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
        this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
          this.horarios = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      bloquearFecha( ){
        this.cargar = true

        const payload = {
          dia: this.dia,
          horario: this.horario,
          sucursal: this.sucursal,
          idturnos: this.idturnos,
          idvendedor: this.getdatosUsuario.idusuarios
        }

        return this.$http.post('bloquear.fecha', payload ).then(response=>{
          this.fechaValida = true
        }).catch( error =>{
          this.fechaValida = false
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      desbloquearFecha( ){
        this.cargar = true

        const payload = {
          dia: this.dia,
          horario: this.horario,
          sucursal: this.sucursal,
          idturnos: this.idturnos
        }

        return this.$http.post('desbloquear.fecha', payload ).then(response=>{
          this.fechaValida = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      addMercancia( ){

        this.mercancias.push({
          ...this.mercancia,
          cantidad: this.cantidad,
          total   :  ( this.cantidad * this.mercancia.precio).toFixed( 2 )
        })

        console.log( this.mercancias)

        this.cantidad = 1
        this.mercancia = null

      },

      editItem (item) {
        this.editedIndex = this.contratos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.contratos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('contratos.update/' + this.editedItem.idarticulos, this.editedItem).then(response=>{
          this.cargar = true
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      addContrato( ){

        const payload = {

          cliente   : this.cliente,
          articulos : this.articulosSeleccionados,
          platillos : this.platillosSeleccionados,
          extras    : this.mercancias,
          festejado : this.festejado,
          dia       : this.dia,
          hora      : this.horario,
          tematica  : 'NA',
          porcumplir: 'NA',
          anticipo  : this.anticipo,
          tipo_pago : this.tipo_pago,
          idusuarios: this.getdatosUsuario.idusuarios,
          sucursal  : this.sucursal,
          total     : this.total_pago,
          email     : this.email,
          telefono  : this.telefono,
          direccion : this.direccion,
          idturnos  : this.idturnos,
          segundo_contacto: this.segundo_contacto,
          folio_pago: this.folio_pago,
          idvendedor    : this.getdatosUsuario.idusuarios

        }

        return this.$http.post('contratos.add', payload ).then(response=>{
          this.cliente = null
          this.articulosSeleccionados = []
          this.platillosSeleccionados = []
          this.mercancias = []
          this.festejado = null
          this.dia = null
          this.hora = null
          this.tematica = null
          this.porcumplir = null
          this.anticipo = null
          this.tipo_pago = null
          this.cliente    = null
          this.email      = null
          this.telefono   = null
          this.direccion  = null
          this.opCompra   = null
          this.pago       = null
          this.segundo_contacto = null
          this.dialogConfirmarCompra = false
          this.mercancias = []
          this.dialogConfirmarContrato = false

          this.close( )

          this.validarSuccess('Datos grabados correctamente')
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if(this.editedItem.proveedor == ''){
          this.validarErrorDirecto('Favor de llenar todos los campos')
        }
        this.cargar = true

        if (this.editedIndex > -1) {
          // Lo mandapos por el EP
          this.$http.put('contratos.update/' + this.editedItem.idarticulos, this.editedItem).then(response=>{
            this.close()
            this.validarSuccess( response.body.message )
            this.initialize()
          }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
          // Lo mandapos por el EP
          this.$http.post('contratos.add', this.editedItem).then(response=>{
            this.close()
            this.initialize()
            this.cargar = false
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },

      saveCliente( ) {

        this.cargar = true

        const payload = {

          cliente  : this.cliente,
          email    : this.email,
          telefono : this.telefono,
          direccion: this.direccion

        }

        if( !this.cliente || !this.telefono  || !this.direccion || !this.email ){

          return this.validarErrorDirecto( 'Favor de llenar todos los datos.' )

        }
        
        // Lo mandapos por el EP
        this.$http.post('clientes.add', payload).then(response=>{
          this.cliente   = null
          this.email     = null
          this.telefono  = null
          this.direccion = null
          this.opCompra  = null
          this.pago      = null
          this.validarSuccess('Prospecto generado correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      saveCompra( ){
        this.cargar = true

        const payload = {

          cliente       : this.cliente,
          email         : this.email,
          telefono      : this.telefono,
          direccion     : this.direccion,
          mercancias    : this.mercancias,
          totalMercancia: this.totalMercancia,
          pago          : this.pago,
          idvendedor    : this.getdatosUsuario.idusuarios,
          tipo_pago     : this.tipo_pago,
          folio_pago    : this.folio_pago
        }

        // if( !this.cliente || !this.telefono ){

        //   return this.validarErrorDirecto( 'Favor de llenar los datos principales como cliente y teléfono' )

        // }
        
        // Lo mandapos por el EP
        this.$http.post('mercancias.add', payload).then(response=>{
          this.cliente    = null
          this.email      = null
          this.telefono   = null
          this.direccion  = null
          this.opCompra   = null
          this.pago       = null
          this.tipo_pago        = null
          this.folio_pago       = null
          this.dialogConfirmarCompra = false
          this.mercancias       = []
          this.montoIngresado   = null
          this.validarSuccess('Prospecto generado correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      }
    },
  }
</script>


